import { getSessionUUID } from '../components/lib/AuthToken'; // Import the utility function
import logger from "../utils/logger";

export const use_send_notification = async (token, message) => {

    try{
        // User input
        const body = {
            token: token,
            message: message
        };

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/notifications/notification', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Notification Sent', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to send notification', status: response.status };
        }
    } catch (err) {
        logger.error("Error sending notification:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }    
}


export const check_pending_orders = async () => {

    try{
        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({}),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/notifications/pending_orders', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            logger.log("Pending orders response:", responseBody);
            return { count: responseBody.count, status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to fetch pending orders', status: response.status };
        }
    } catch (err) {
        logger.error("Error fetching pending orders:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}